export const IMG = {
  logo: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/n6yuc1d8_seedkeepers%20new%20logo.png",
  hero: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/rohxjn7u_seedkeepers%20main.png",
  fruits: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/yyy0h2g4_seedkeepers%206.jpg",
  seedsBowl: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/ywc7prkh_seedkeepers%207.jpg",
  acaciaPods: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/bvjzpfsz_seedkeepers%205.jpg",
  polytunnel: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/l608f82j_seedkeepers%201.jpg",
  ownerPractitioner: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/uj4fcspu_seedkeepers%202.jpg",
  handsSeeds: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/g41uv7bx_seedkeepers%203.jpg",
  fieldVehicle: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/do47joig_seedkeepers%204.jpg",
  truck: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/jpfm03kp_seedkeepers%20truck%20with%20logo.png",
  containerSeedBank: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/21iyej2i_wisdomkeepers_Small-scale_community_seed_bank_inside_a_conver_b4407d8d-1418-4270-98ac-9aea60d81c61_2.png",
  william: "https://customer-assets-m6fa6gv7.emergentagent.net/job_seedkeepers-au/artifacts/4nkwptdb_william%20-%20garden.jpg",
  // New uploads (12–16)
  seedPods: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/ly3npdmw_seedkeepers%2012.jpg",
  siftingHands: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/nc4ls80j_seedkeepers%2013.jpg",
  shadehouseBuild: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/iioz2xnh_seedkeepers%2014.jpg",
  seedShelvesAlt: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/pte0dmym_seedkeepers%2015.jpg",
  labelledJars: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/kq4ubmst_seedkeepers%2016.jpg",
  // App / data screenshots (for Bush Maps & SPIRIT)
  collectionApp: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/59nn6yhj_field%20collection%20app%20with%20hand.png",
  collectionData: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/jisnwfaw_seed%20collection%20data.png",
  // Bush Botanics imagery
  essentialOils: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/slpyfnzs_essential%20oils.jpg",
  ngaanyatjarraBushFoods: "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/qctzdnrj_bush%20foods%20and%20botanicals%20of%20the%20Ngaanyatjarra%20lands.png",
  // Mission — Linda Eddy & William Martin on Country
  mission: "https://customer-assets-m6fa6gv7.emergentagent.net/job_seedkeepers-au/artifacts/pd1bedol_Linda%20Eddy%20and%20William%20Martin%20photo%20by%20mai%20lin%20-%20imaged%20used%20with%20permission%20from%20elder.jpg",
  // Labelled seed collection tubes — provenance, species, care
  seedTubes: "https://customer-assets-m6fa6gv7.emergentagent.net/job_seedkeepers-au/artifacts/eakrc67s_seeds%20in%20tubes%20revised.webp",
};

export const CAPABILITY_PDF =
  "https://customer-assets.emergentagent.com/job_seedkeepers-au/artifacts/jbhujkwo_seedkeepers%20-%20capability%20statement.pdf";

// Verbatim from seedkeepers.com (the founder's words)
export const WILLIAM_QUOTE =
  "We must not underestimate the power of the seed. It is a symbol for regeneration, for growth, and for hope. When we hold seeds in our hands, we hold the future of generations, the future of homelands, and the rebirth of Traditional cultural practices.";

export const CONTACT_INFO = {
  founder: "William Martin",
  founderSince: "2002",
  email: "william@seedkeepers.com.au",
  phone: "+61 4 117 98 772",
  location: "Cairns, Australia",
  partner: { name: "National Indigenous Seed Bank Project", url: "https://nisb.com.au/" },
  podcast: {
    title: "The Seed Savers — ABC Earshot",
    url: "https://www.abc.net.au/listen/programs/earshot/the-seed-savers/13757304",
  },
};

export const TOP_BANNER =
  "Australia cannot restore what it cannot seed. Building a restoration economy requires investment in the people, knowledge, infrastructure and cultural authority that make restoration possible.";

export const AUDIENCES = [
  {
    slug: "traditional-owners",
    label: "Traditional Owner Groups",
    no: "01",
    short: "Custodians of Country leading stewardship, restoration and cultural authority.",
    promise:
      "We work alongside Traditional Owner groups to establish on-Country seed banks, design governance that keeps decision-making with Country, and build long-term expert-led restoration enterprises.",
    bullets: [
      "On-Country seed bank design and governance",
      "Indigenous seed enterprise development",
      "Provenance and cultural protocols",
      "Long-term stewardship agreements",
    ],
  },
  {
    slug: "rangers",
    label: "Ranger Programs",
    no: "02",
    short: "Ranger teams delivering monitoring, seed collection and on-Country restoration.",
    promise:
      "We support ranger programs to build seed collection capacity, integrate ecological knowledge with restoration practice, and create durable supply lines for priority species.",
    bullets: [
      "Seed collection training and tooling",
      "Storage and provenance protocols",
      "Species lists and collection calendars",
      "Pathways into restoration economies",
    ],
  },
  {
    slug: "mining",
    label: "Mining & Resources",
    no: "03",
    short: "Organisations seeking reliable seed supply and stronger rehabilitation outcomes.",
    promise:
      "We help mining and resources companies de-risk rehabilitation by planning seed supply early, partnering meaningfully with Traditional Owners, and building restoration-ready infrastructure on or near sites.",
    bullets: [
      "Seed supply planning across mine life",
      "Indigenous participation pathways",
      "Seed Production Area design",
      "Restoration readiness assessments",
    ],
  },
  {
    slug: "practitioners",
    label: "Restoration Practitioners",
    no: "04",
    short: "Ecologists, contractors and consultants delivering restoration on the ground.",
    promise:
      "We partner with practitioners to plan for restoration readiness, secure quality seed of the right provenance, and embed Traditional Owner engagement from the start.",
    bullets: [
      "Restoration readiness planning",
      "Species and provenance advice",
      "Indigenous engagement frameworks",
      "Quality assurance for seed supply",
    ],
  },
  {
    slug: "funders",
    label: "Funders & Investors",
    no: "05",
    short: "Supporting the infrastructure, enterprises and systems that restoration depends upon.",
    promise:
      "We help funders direct capital into the parts of the restoration economy that actually unlock outcomes — seed systems, Indigenous capability and long-term stewardship.",
    bullets: [
      "Investment thesis for seed systems",
      "Impact frameworks and metrics",
      "Co-design with Traditional Owners",
      "Portfolio of investable opportunities",
    ],
  },
];

export const CHALLENGES = [
  { no: "01", title: "Seed Supply", body: "Australia's restoration ambitions are growing faster than its native seed supply. Biodiversity programs, mine rehabilitation and carbon projects all depend on seed that is often unavailable, inaccessible or not fit for purpose." },
  { no: "02", title: "Restoration Readiness", body: "Many restoration projects begin long before the seed system is understood. Species requirements, provenance planning, collection windows and production capacity are often considered too late, creating risks that could have been addressed years earlier." },
  { no: "03", title: "Indigenous Participation", body: "Traditional Owners are frequently engaged after restoration priorities have already been established. Yet cultural authority, local knowledge and stewardship are most valuable at the beginning of the process, when decisions about Country are being made." },
];

export const SOLUTIONS = [
  { no: "01", title: "On-Country Seed Banks", body: "Decentralised seed banks built with Traditional Owners. Collection, storage and stewardship sit with Country, supported by horticultural and provenance practice." },
  { no: "02", title: "Seed Production Areas", body: "Designed to scale supply of priority restoration species. Reliable, traceable, ecologically appropriate — the missing middle of Australia's restoration economy." },
  { no: "03", title: "Expert-Led Restoration Enterprises", body: "Long-term business models that give Traditional Owners durable participation in restoration economies — not one-off contracts." },
];

export const SERVICES = [
  { title: "Seed System Development", body: "Assessment, planning and implementation of regional and project-level seed systems — from species lists to governance." },
  { title: "On-Country Seed Banks", body: "Design, governance and operational support for expert-led seed banks. Storage, provenance, protocols, people." },
  { title: "Seed Production Areas", body: "Species selection, site design, production systems and quality assurance for SPAs at a range of scales." },
  { title: "Indigenous Participation and Restoration Readiness", body: "Frameworks for meaningful Traditional Owner engagement and project-level restoration readiness assessments." },
  { title: "Mining and Rehabilitation Support", body: "Seed supply planning across mine life, Indigenous participation pathways and restoration-readiness assessments." },
  { title: "Native Seed Collection & Restoration Training", body: "On-Country training for Indigenous rangers and environmental practitioners — seed collection, provenance, data, restoration readiness and career pathways.", link: "/training" },
];

export const PROJECTS = [
  { name: "Central Desert — Bush Botanics", region: "Central Desert", image: IMG.ownerPractitioner, body: "Working with desert communities on bush food production and seed systems that connect cultural use, restoration and enterprise." },
  { name: "National — Seed Systems & Sector Development", region: "National", image: IMG.truck, body: "Advisory work with governments and funders on the seed systems Australia needs to meet its restoration commitments." },
  { name: "Growing Country", region: "Multi-region", image: IMG.containerSeedBank, body: "A program connecting food security, cultural landscapes and seed systems — Country as productive infrastructure." },
  { name: "Indigenous Native Seed Collection & Restoration Training", region: "On-Country", image: IMG.handsSeeds, body: "On-Country training for Indigenous rangers and environmental practitioners — seed collection, provenance, data, restoration readiness and career pathways into the restoration economy.", link: "/training" },
];

export const STORIES = [
  { title: "The Grandmothers", lede: "What three Elders taught us about seed, time and patience.", image: IMG.ownerPractitioner, body: "They knew which trees produced when. They knew which seasons would fail. They knew the names of seeds that ecologists are still learning to identify. The Grandmothers were the seed system long before anyone called it one." },
  { title: "Seed Collection on Country", lede: "A week of collection with the ranger team — and what it taught us about timing.", image: IMG.siftingHands, body: "This work reminded us that seed collection is not a logistics problem. It is a relationship — with people, with Country, with the year you happen to be in." },
  { title: "What Healthy Country Looks Like", lede: "Health is visible if you know what to look for. Restoration begins with seeing.", image: IMG.fruits, body: "Healthy Country is legible: in the seed set on a wattle, in the soil under your feet, in the kids who can name the species. The site visit is not optional." },
  { title: "Building the Shadehouse", lede: "A community seed bank starts with steel, shade, and a long timeline.", image: IMG.shadehouseBuild, body: "Most seed bank stories begin with seed. This one begins with steel. A shadehouse is the unglamorous middle of a long story — and the structural commitment that says: we will be here in ten years." },
  { title: "The Missing Link in Restoration", lede: "Why so many restoration plans never reach the ground — and what to do about it.", image: IMG.truck, body: "The missing link is not goodwill or ambition. It is the biological infrastructure that connects intent to outcome: seed banks, production areas, governance, and the people who steward them." },
];

export const MODEL_STEPS = [
  { label: "Country", body: "Where it begins. Cultural authority and ecological reality." },
  { label: "Knowledge", body: "Indigenous ecological knowledge braided with horticultural and restoration science." },
  { label: "Seed", body: "Collected, stored and stewarded — on Country, by people of Country." },
  { label: "Production", body: "Seed production areas that scale supply for priority restoration species." },
  { label: "Restoration", body: "Restoration delivered with the right seed, the right people and the right provenance." },
  { label: "Stewardship", body: "Long-term care for the systems we build — not project handovers." },
];

export const CRISIS_STATS = [
  { number: "10×", label: "Estimated gap between native seed demand and reliable supply for priority restoration species in some regions." },
  { number: "<5%", label: "Share of restoration plans nationally with documented long-term seed planning, by independent estimates." },
  { number: "50+", label: "Years of horticultural and on-Country experience SeedKeepers draws on to build seed systems." },
  { number: "Country first", label: "Every program begins with Traditional Owner authority — not after the species list is finalised." },
];

// ---------- Stewardship (thought-leadership) ----------
export const STEWARDSHIP_INTRO =
  "Seed is more than a restoration input. It carries the genetic diversity, ecological resilience and cultural knowledge that underpin healthy landscapes. For thousands of generations, Indigenous communities have stewarded Country through relationships with plants, seasons, water, fire and place. SeedKeepers exists to strengthen those stewardship systems through community seed banks, seed collection, storage, restoration capability and Indigenous enterprise development.";

export const SEED_CARRIES = [
  "Genetic diversity",
  "Cultural knowledge",
  "Ecological resilience",
  "Food security",
  "Restoration potential",
];

export const SEED_STEWARDSHIP_ACTIVITIES = [
  "Seed collection",
  "Provenance management",
  "Seed storage",
  "Seed production",
  "Restoration planning",
  "Cultural protocols",
  "Knowledge transfer",
];

export const CLIMATE_SEED_SUPPORTS = [
  "Biodiversity conservation",
  "Habitat restoration",
  "Freshwater protection",
  "Erosion control",
  "Food security",
  "Carbon and restoration projects",
];

export const STEWARDSHIP_OUTCOMES = [
  { no: "01", label: "Natural", body: "Healthier landscapes and stronger biodiversity." },
  { no: "02", label: "Cultural", body: "Protection and transfer of traditional knowledge." },
  { no: "03", label: "Social", body: "Community capability and local leadership." },
  { no: "04", label: "Economic", body: "Sustainable Indigenous enterprises and livelihoods." },
];

// ---------- "What We Do" — new Services overview (six categories) ----------
export const WHAT_WE_DO = [
  {
    no: "01",
    title: "Native Seed Enterprise Development",
    body: "We work with communities to establish seed enterprises grounded in cultural authority, ecological integrity and local aspirations.",
    items: [
      "Seed business planning",
      "Market readiness",
      "Seed supply systems",
      "Operational planning",
      "Enterprise development",
    ],
    link: "/contact",
    cta: "Discuss enterprise development",
  },
  {
    no: "02",
    title: "Community Seed Banks",
    body: "Decentralised seed bank infrastructure — secure storage, governance and a hub for restoration, ranger and enterprise activity.",
    items: [
      "Seed bank establishment",
      "Storage systems",
      "Equipment and infrastructure",
      "Seed management protocols",
      "Community engagement",
    ],
    link: "/infrastructure",
    cta: "See seed bank infrastructure",
  },
  {
    no: "03",
    title: "Ranger Training",
    body: "On-Country training for Indigenous rangers and environmental practitioners across the full seed and restoration cycle.",
    items: [
      "Seed collection techniques",
      "Provenance and genetics",
      "Seed processing and storage",
      "Restoration planning",
      "Ecological monitoring",
    ],
    link: "/training",
    cta: "Explore training",
  },
  {
    no: "04",
    title: "Restoration Readiness",
    body: "We help projects prepare for restoration before activity begins — assessing seed supply, species priorities and pathways.",
    items: [
      "Restoration planning",
      "Seed supply assessments",
      "Species prioritisation",
      "Nursery development",
      "Restoration economy pathways",
    ],
    link: "/contact",
    cta: "Plan a project",
  },
  {
    no: "05",
    title: "Ecological Mapping",
    body: "Bush Maps connect ecological knowledge with spatial tools to support seed collection, restoration and cultural landscape planning.",
    items: [
      "Bush Maps",
      "Seed collection zones",
      "Species mapping",
      "Restoration opportunity mapping",
      "Cultural landscape mapping",
    ],
    link: "/bush-maps",
    cta: "See Bush Maps",
  },
  {
    no: "06",
    title: "Digital Tools",
    body: "SPIRIT and supporting digital systems help communities manage seed, provenance, monitoring and restoration data.",
    items: [
      "SPIRIT platform",
      "Provenance management",
      "Monitoring systems",
      "Restoration tracking",
      "Seed inventory systems",
    ],
    link: "/seed-intelligence#spirit",
    cta: "Access SPIRIT",
  },
];

// ---------- Indigenous Seed Enterprises (Home section) ----------
export const ENTERPRISE_SUPPORTS = [
  "Indigenous seed enterprises",
  "Ranger seed collection programs",
  "Community seed banks",
  "Seed production areas",
  "Nursery development",
  "Restoration businesses",
  "Stewardship services",
];

// ---------- Community Seed Banks (extended) ----------
export const SEED_BANK_SUPPORTS = [
  "Local seed supply",
  "Species conservation",
  "Ranger training",
  "School engagement",
  "Knowledge sharing",
  "Restoration projects",
  "Enterprise development",
];

// ---------- Bush Botanics ----------
export const BUSH_BOTANICS_PRODUCTS = [
  { title: "Traditional medicines", body: "Plant-based knowledge of healing, passed through generations." },
  { title: "Bush foods", body: "Culturally significant species with growing market demand." },
  { title: "Essential oils", body: "Distilled from native species — value-add with provenance." },
  { title: "Natural skincare", body: "Botanically-derived products grounded in cultural use." },
  { title: "Native plant products", body: "Handmade paper, natural fibres and crafted goods." },
  { title: "Cultural tourism experiences", body: "On-Country learning and visitor experiences." },
];

// ---------- Bush Maps ----------
export const BUSH_MAPS_USES = [
  "Seed collection zones",
  "Cultural plant species",
  "Bush food species",
  "Traditional medicines",
  "Ecosystems and habitats",
  "Restoration priorities",
  "Ranger activities",
  "Monitoring sites",
];

// ---------- Restoration Economy sectors ----------
export const RESTORATION_ECON_SECTORS = [
  "Biodiversity projects",
  "Mining rehabilitation",
  "Conservation programs",
  "Carbon and climate projects",
  "Government restoration targets",
  "Industry stewardship commitments",
];
